// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16Mhv","actionsCol":"EnrolledClinics_actionsCol__2Qt4i"};